
<div class="ws-accent-card ws-accent-card--gold" [class.collapsed]="disabled">
    <div class="ws-accent-card__head">
        <h3 class="ws-accent-card__title">{{ title }}</h3>
        <span class="ws-accent-card__empty-marker" *ngIf="disabled">&mdash;</span>
    </div>
    <div class="ws-accent-card__body">
        <p>How has managing the Meal Plan been this week?</p>
        <div class="row mt-3">
            <div class="col-md-6">
                <div class="card {{ disabled? 'bg-light-subtle' : 'bg-warning-subtle' }} border-0 shadow-sm rounded-4 p-3">
                    <div class="card-body p-0">
                        <h6 class="fw-semibold mb-3">This week's challenges</h6>

                        <p class="mb-2 text-muted">Loved one has struggled with</p>

                        <div class="d-flex align-items-center text-body">
                            <i *ngIf="disabled" class="bi bi-exclamation-triangle-fill text-gray me-2"></i>
                            <span *ngIf="disabled">No data</span>
                            <span *ngIf="!disabled">
                                @for (challenge of visibleChallenges; track challenge) {
                                    <i class="bi bi-exclamation-triangle-fill text-warning me-2"></i>
                                    {{ challenge }}<br>
                                }
                                @if (moreChallengesCount > 0) {
                                    <span class="text-muted">+{{ moreChallengesCount }} more</span>
                                }
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card bg-wins-tint border-0 shadow-sm rounded-4 p-3">
                    <div class="card-body p-0">
                        <h6 class="fw-semibold mb-3">This week's wins</h6>

                        <p class="mb-2 text-muted">Loved one has</p>

                        <div class="d-flex align-items-center text-body">
                            <i *ngIf="disabled" class="bi bi-check-circle-fill text-gray me-2"></i>
                            <span *ngIf="disabled">No data</span>
                            <span *ngIf="!disabled">
                                @for (win of visibleWins; track win) {
                                    <i class="bi bi-check-circle-fill text-green me-2"></i>
                                    {{ win }}<br>
                                }
                                @if (moreWinsCount > 0) {
                                    <span class="text-muted">+{{ moreWinsCount }} more</span>
                                }
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
